<template>
  <main class="min-h-[60vh] flex items-center justify-center px-4 py-16">
    <section class="w-full max-w-[640px] rounded-[2.4rem] border border-black/10 bg-white p-8 shadow-sm text-center space-y-4">
      <p class="m-0 text-[1.8rem] font-semibold text-black">¡Genial! Has reservado tu cita</p>
      <p class="m-0 text-[1.4rem] text-[color:var(--gray)]">
        Recibirás un email de confirmación ahora y un recordatorio antes de la cita.
      </p>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CheckoutThankYouView'
});
</script>
